export default {
  UserList: () => import('@/views/system/user/listPage/UserList'),
}